import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Layout from "../../../Layout/Layout";
import { InputField } from "../../../Components/formElements/InputField";
import ItemServiceV2 from "../../../services/human_resource_appCommonService";
import ItemServiceV3 from "../../../services/customer_appCommonService";
import { useSelector } from "react-redux";
import ItemService from "../../../services/supplier_appCommonService";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { getTodaysData } from "../../../common/Validations";
import FailureModal from "../../../Components/Modal/supplier_app/FailureModal";
import { ComboboxField } from "../../../Components/formElements/ComboboxField";
import RichTextEditor from "../../../Components/Editor/RichTextEditor";
import FileUploadComponent from "../../../Components/formElements/FileUploadComponent";
import FileViewerModal from "../../../Components/FileViewer/FileViewerModal";
import HRConstants from "../../../common/HRConstants";
import { TextAreaField } from "../../../Components/formElements/TextAreaField";
import DataTable from "react-data-table-component";
import Constants from "../../../common/SupplierConstants";
import HrProjectServices from "../Project/HrProjectServices";

const TaskDetails = () => {
  localStorage.setItem("menu", "Task Manage");
  localStorage.setItem("submenu", "Task List");
  const menuData = useSelector((state) => state?.menu);
  let taskNr = useSelector((state) => state?.hr?.task?.taskNr);
  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [getShowFailureModal, setShowFailureCashRequest] = useState(false);
  const [getDropdownData, setDropdownData] = useState("");
  const [getMenu, setMenu] = useState([]);
  const [getAppData, setAppData] = useState([]);
  const [getProjectList, setProjectList] = useState([]);
  const [getPhaseList, setPhaseList] = useState([]);
  const [getTaskDetails, setTaskDetails] = useState([]);
  const [, /*selectedDropdown*/ setSelectedDropdown] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [isDraftSaving, setIsDraftSaving] = useState(false);
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  const [getDelegation, setDelegation] = useState();
  // eslint-disable-next-line
  const [getPhaseData, setPhaseData] = useState();
  const [getProjectRawData, setProjectRawData] = useState([]);
  const [getClientList, setClientList] = useState([]);
  const [getEmpList, setEmpList] = useState([]);
  const [getServicesLineItemModal, setServicesLineItemModal] = useState(false);
  const [getServicesLineItemIndex, setServicesLineItemIndex] = useState(0);
  const [getServicesLineItemText, setServicesLineItemText] = useState([]);
  const [getServiceTitle, setServiceTitle] = useState("");
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };
  const [formInputs, setFormInputs] = useState({
    gateCode: "",
    inDate: getTodaysData() || "",
  });
  const status = formInputs?.headerStatus?.toLowerCase();
  const taskStatuss = [
    { id: 1, name: "Started" },
    { id: 2, name: "In Progress" },
    { id: 3, name: "On Hold" },
    { id: 4, name: "Completed" },
    { id: 5, name: "Closed" },
  ];
  const getMasterData = async () => {
    let obj4 = {
      type: "CLT",
    };
    await ItemServiceV2.getClientDrop(obj4).then((item) => {
      if (item?.status === 200) {
        setClientList(item?.data);
      } else {
        setClientList([]);
        console.log(">> Error: Loading getClientDrop");
      }
    });
  };
  const getEmpDrop = async () => {
    let obj4 = {
      type: "EMP",
    };
    await ItemServiceV2.getClientDrop(obj4).then((item) => {
      if (item?.status === 200) {
        setEmpList(item?.data);
      } else {
        setEmpList([]);
        console.log(">> Error: Loading getEmpDrop");
      }
    });
  };
  useEffect(() => {
    getMasterData();
    getEmpDrop();
  }, []);
  const hideServicesLineItem = () => {
    setServicesLineItemModal(false);
  };
  const handlePhases = (data) => {
    setPhaseData((prevPhases) =>
      prevPhases.map((item) =>
        item.local_id === getServicesLineItemIndex
          ? { ...item, services: data }
          : item,
      ),
    );
  };
  const fetchProjectsForClient = async (clientCode) => {
    let obj = {
      documentNumber: clientCode,
    };
    const toastId = toast.loading("Loading projects...", {
      position: "top-right",
    });

    await ItemServiceV3.getCustomerDetail(obj).then((item) => {
      if (item?.status === 200) {
        const projects = item?.data?.[0]?.projectDetails || [];
        setProjectRawData(projects);
        const formatted = projects.map((p) => ({
          id: p.projectNr,
          code: p.projectNr,
          description: p.status || "",
          name: `${p.projectNr}${p.status ? " - " + p.status : ""}`,
        }));
        setProjectList(formatted);
      } else {
        setProjectRawData([]);
        setProjectList([]);
        toast.error(item?.message || "Unable to load projects", {
          duration: 3000,
          position: "top-right",
        });
      }
      toast.dismiss(toastId);
    });

    // reset dependent dropdowns whenever client changes
    setPhaseList([]);
    setFormInputs((prev) => ({ ...prev, projectNr: "", phase: "" }));
  };
  useEffect(() => {
    if (getDropdownData?.textField === "clientName" && getDropdownData?.code) {
      fetchProjectsForClient(getDropdownData.code);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);
  // useEffect(() => {
  //   if (getDropdownData?.textField === "projectNr" && getDropdownData?.code) {
  //     const selectedProject = getProjectRawData.find(
  //       (p) => String(p.projectNr) === String(getDropdownData.code),
  //     );

  //     const projectPhase = selectedProject?.projectPhase || {};

  //     const predefinedPhases = [
  //       {
  //         phaseName: "Project Preparation",
  //         description: "Initial project planning, scope, and team setup.",
  //       },
  //       {
  //         phaseName: "Business Blueprint",
  //         description: "Document business requirements and processes.",
  //       },
  //       {
  //         phaseName: "Realization",
  //         description: "Configure and build the solution based on blueprint.",
  //       },
  //       {
  //         phaseName: "Final Preparation",
  //         description: "Testing, training, and cutover preparation.",
  //       },
  //       {
  //         phaseName: "Go-Live and Support",
  //         description: "Go-live and post go-live support.",
  //       },
  //     ];

  //     const formattedPhases = Object.entries(projectPhase).map(
  //       ([phaseKey, services], index) => {
  //         const phaseName = predefinedPhases[index]?.phaseName || phaseKey;
  //         return {
  //           id: phaseKey,
  //           code: phaseKey,
  //           description: predefinedPhases[index]?.description || "",
  //           name: `Phase ${index + 1} - ${phaseName}`,
  //           services: Array.isArray(services) ? services : [],
  //         };
  //       },
  //     );

  //     setPhaseList(formattedPhases);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [getDropdownData, getProjectRawData]);
  useEffect(() => {
    const projectCode =
      getDropdownData?.textField === "projectNr"
        ? getDropdownData?.code
        : formInputs?.projectNr;

    if (!projectCode || !getProjectRawData?.length) {
      return;
    }

    const selectedProject = getProjectRawData.find(
      (p) => String(p.projectNr) === String(projectCode),
    );

    if (!selectedProject) {
      setPhaseList([]);
      setSelectedPhaseServices([]);
      return;
    }

    const projectPhase = selectedProject?.projectPhase || {};

    const predefinedPhases = [
      {
        phaseName: "Project Preparation",
        description: "Initial project planning, scope, and team setup.",
      },
      {
        phaseName: "Business Blueprint",
        description: "Document business requirements and processes.",
      },
      {
        phaseName: "Realization",
        description: "Configure and build the solution based on blueprint.",
      },
      {
        phaseName: "Final Preparation",
        description: "Testing, training, and cutover preparation.",
      },
      {
        phaseName: "Go-Live and Support",
        description: "Go-live and post go-live support.",
      },
    ];

    const formattedPhases = Object.entries(projectPhase).map(
      ([phaseKey, services], index) => ({
        id: phaseKey,
        code: phaseKey,
        description: predefinedPhases[index]?.description || "",
        name: `Phase ${index + 1} - ${
          predefinedPhases[index]?.phaseName || phaseKey
        }`,
        services: Array.isArray(services) ? services : [],
      }),
    );

    setPhaseList(formattedPhases);
  }, [getDropdownData, getProjectRawData, formInputs?.projectNr]);
  const [getSelectedPhaseServices, setSelectedPhaseServices] = useState([]);
  const taskIdList = (getSelectedPhaseServices || []).map((service) => ({
    id: service.taskID,
    code: service.taskID,
    description: service.serviceDescription || "",
    name: `${service.taskID} - ${service.serviceDescription || ""}`,
  }));
  // useEffect(() => {
  //   if (getDropdownData?.textField === "phase" && getDropdownData?.code) {
  //     const selectedPhase = getPhaseList.find(
  //       (ph) => String(ph.code) === String(getDropdownData.code),
  //     );
  //     setSelectedPhaseServices(selectedPhase?.services || []);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [getDropdownData, getPhaseList]);
  useEffect(() => {
    const phaseCode =
      getDropdownData?.textField === "phase"
        ? getDropdownData?.code
        : formInputs?.phase;

    if (!phaseCode || !getPhaseList?.length) {
      setSelectedPhaseServices([]);
      return;
    }

    const selectedPhase = getPhaseList.find(
      (ph) => String(ph.code) === String(phaseCode),
    );

    setSelectedPhaseServices(selectedPhase?.services || []);
  }, [getDropdownData, getPhaseList, formInputs?.phase]);
  const showServicesLineItem = (index, data, type) => {
    setServicesLineItemModal(true);
    setServicesLineItemIndex(index);
    setServicesLineItemText(data);
    setServiceTitle(type === "SER" ? "Services List" : "Schedule List");
  };
  const delegationColumns = [
    {
      name: (
        <>
          <i className="bi bi-person labelIcon"></i>
          Current Assigned To
        </>
      ),
      selector: (row) => row.currentAssignedTo || "--",
      sortable: true,
      width: "220px",
    },
    {
      name: (
        <>
          <i className="bi bi-person-badge labelIcon"></i>
          Current Employee Code
        </>
      ),
      selector: (row) => row.currentEmployeeCode || "--",
      sortable: true,
      width: "220px",
    },
    {
      name: (
        <>
          <i className="bi bi-person-plus labelIcon"></i>
          New Assigned To
        </>
      ),
      selector: (row) => row.newAssignedTo || "--",
      sortable: true,
      width: "220px",
    },
    {
      name: (
        <>
          <i className="bi bi-person-vcard labelIcon"></i>
          New Employee Code
        </>
      ),
      selector: (row) => row.newEmployeeCode || "--",
      sortable: true,
      width: "220px",
    },
    {
      name: (
        <>
          <i className="bi bi-calendar-event labelIcon"></i>
          Delegation Date
        </>
      ),
      selector: (row) => row.delegationDate || "--",
      cell: (row) => (
        <span>
          {row.delegationDate
            ? new Date(row.delegationDate).toLocaleDateString()
            : "--"}
        </span>
      ),
      sortable: true,
      width: "170px",
    },
    {
      name: (
        <>
          <i className="bi bi-arrow-left-right labelIcon"></i>
          Delegation Reason
        </>
      ),
      selector: (row) => row.delegationReason || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: (
        <>
          <i className="bi bi-chat-left-text labelIcon"></i>
          Remarks
        </>
      ),
      selector: (row) => row.remarks || "--",
      sortable: true,
      width: "200px",
    },
  ];
  useEffect(() => {
    if (!getDropdownData) return;

    if (getDropdownData?.textField === "assignedTo") {
      setFormInputs((prev) => ({
        ...prev,
        assignedTo:
          getDropdownData?.name || getDropdownData?.employeeName || "",
        employeeCode:
          getDropdownData?.code || getDropdownData?.employeeCode || "",
      }));
    }
  }, [getDropdownData]);
  const priority = [
    { id: 1, name: "High" },
    { id: 2, name: "Low" },
    { id: 2, name: "Medium" },
  ];

  const navigate = useNavigate();
  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };
  /* pop failure modal data*/
  const failureCashRequestUpdate = {
    title: "Warning",
    ErrorMsg: "",
  };
  const onSuccessUploadDocumentType = (data) => {
    setFormInputs((formInputs) => ({
      ...formInputs,
      [data.fieldName]: data.attachmentId,
    }));
  };
  const [getFailureCashRequestUpdate] = useState(failureCashRequestUpdate);

  //Validations
  const [validation, setValidation] = useState({});
  const handleInputChange = ({ target: { name, value } }) => {
    const errors = {}; // Add validations here if needed
    setFormInputs((prev) => ({ ...prev, [name]: value }));
    setValidation((prev) => ({
      ...prev,
      [name]: errors[name] || "",
    }));
  };
  const [editorContent, setEditorContent] = useState("");
  const [getSubTask, setSubTask] = useState([]);
  const subTaskInitialData = {
    id: "",
    subTaskName: "",
    subTaskDescription: "",
    assignedTo: "",
    startDate: "",
    startTime: "",
    endDate: "",
    endTime: "",
    priority: "",
    status: "",
    supportingDocument: "",
  };
  const addSubTask = () => {
    setSubTask((prev) => {
      const nextLocalId =
        prev.length > 0
          ? Math.max(...prev.map((s) => Number(s.local_id) || 0)) + 1
          : 1;
      const newForm = { ...subTaskInitialData, local_id: nextLocalId };
      return [...prev, newForm];
    });
  };

  const removeSubTask = (indexToRemove) => {
    setSubTask((prev) =>
      prev
        .filter((_, index) => index !== indexToRemove)
        .map((item, index) => ({ ...item, local_id: index + 1 })),
    );
  };

  const handleSubTask = (local_id, key, value) => {
    setSubTask((prev) =>
      prev.map((item) =>
        item.local_id === local_id ? { ...item, [key]: value } : item,
      ),
    );
    setValidation((prev) => ({
      ...prev,
      [`${local_id}_${key}`]: !value ? `${key} is required.` : "",
    }));
  };
  const handleEditorChange = (content) => {
    setEditorContent(content);
  };
  useEffect(() => {
    if (!getDropdownData) return;
    setFormInputs((prev) => ({
      ...prev,
      [getDropdownData?.textField]: getDropdownData?.name,
    }));

    setSelectedDropdown(getDropdownData?.textField);
  }, [getDropdownData]);
  useEffect(() => {
    const menus = Array.isArray(menuData?.data) ? menuData.data : [];

    const formattedMenus = menus
      .filter((menu) => menu?.activity !== "disabled")
      .map((menu) => {
        const desc = typeof menu?.name === "string" ? menu.name : "";
        return {
          menusCode: String(menu?.id ?? ""),
          menusDesc: desc,
          menuId: menu?.id ?? "",
          menuName: desc,
          childId: null,
          childName: null,
          hrefLink: typeof menu?.hrefLink === "string" ? menu.hrefLink : "",
          name: desc,
          label: desc,
          text: desc,
          value: desc,
          title: desc,
          toString: () => desc,
        };
      });

    setMenu(formattedMenus);
  }, [menuData]);

  useEffect(() => {
    gateUpdate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const gateUpdate = async () => {
    let obj = {
      queryName: "Get_HRTaskManage_Details",
      documentNumber: taskNr,
    };
    await ItemServiceV2.generateCustomerQuery(obj).then((item) => {
      if (item?.status === 200) {
        setTaskDetails(item?.data);
        setEditorContent(item?.data?.[0]?.taskInstructions || "");
        // setDelegation(item?.data?.delegation || {});
        setDelegation(item?.data?.[0]?.delegation || {});
      } else {
        setTaskDetails([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };
  const getApplicationMaster = async () => {
    let obj = {};
    await ItemService.getApplicationMaster(obj).then((item) => {
      if (item?.status === 200) {
        const applications = item?.data?.[0]?.appsName || [];
        const formattedApps = applications
          .filter((app) => app?.appStatus !== false)
          .map((app) => {
            const code = String(app?.appCode ?? app?.appsCode ?? app?.id ?? "");
            const desc =
              typeof app?.appName === "string"
                ? app.appName
                : typeof app?.name === "string"
                  ? app.name
                  : "";

            return {
              appsCode: code,
              appsDesc: desc,
              appName: desc,
              name: desc,
              label: desc,
              text: desc,
              value: desc,
              title: desc,
              toString: () => desc,
            };
          });

        setAppData(formattedApps);
      } else {
        setAppData([]);
        console.log(">> Error: Loading getApplicationMaster");
      }
    });
  };
  useEffect(() => {
    getApplicationMaster();
  }, []);
  useEffect(() => {
    if (!getDropdownData) return;
    const isAppsField =
      getDropdownData?.textCode === "appsCode" ||
      getDropdownData?.name === "apps";
    const isMenuField =
      getDropdownData?.textCode === "menusCode" ||
      getDropdownData?.name === "menus";

    if (isAppsField) {
      const selectedApp = getAppData.find(
        (app) => String(app?.appsCode) === String(getDropdownData?.code),
      );

      setFormInputs((prev) => ({
        ...prev,
        apps:
          selectedApp?.appName ||
          selectedApp?.name ||
          getDropdownData?.name ||
          getDropdownData?.label ||
          "",
        appsCode: selectedApp?.appsCode || getDropdownData?.code || "",
        appsDesc:
          selectedApp?.appsDesc ||
          selectedApp?.appName ||
          selectedApp?.name ||
          "",
      }));

      return;
    }

    if (isMenuField) {
      const selectedMenu = getMenu.find(
        (menu) => String(menu?.menusCode) === String(getDropdownData?.code),
      );

      setFormInputs((prev) => ({
        ...prev,
        menus:
          selectedMenu?.menusDesc ||
          getDropdownData?.name ||
          getDropdownData?.label ||
          "",
        menusCode: selectedMenu?.menusCode || getDropdownData?.code || "",
        menusDesc:
          selectedMenu?.menusDesc ||
          getDropdownData?.description ||
          getDropdownData?.name ||
          "",
        menuId: selectedMenu?.menuId || "",
        menuName: selectedMenu?.menuName || "",
        childId: selectedMenu?.childId || "",
        childName: selectedMenu?.childName || "",
        hrefLink: selectedMenu?.hrefLink || "",
      }));
    }
    // eslint-disable-next-line
  }, [getDropdownData, getMenu]);

  const hideFailureModal = () => {
    setShowFailureCashRequest(false);
  };
  // useEffect(() => {
  //   if (getTaskDetails?.length > 0) {
  //     setFormInputs((prev) => ({
  //       ...prev,
  //       ...getTaskDetails[0],
  //     }));
  //   }
  // }, [getTaskDetails]);
  useEffect(() => {
    if (getTaskDetails?.length > 0) {
      const task = getTaskDetails[0];

      setFormInputs((prev) => ({
        ...prev,
        ...task,
      }));
      if (task?.clientCode) {
        fetchProjectsForClient(task.clientCode);
      }
    }
  }, [getTaskDetails]);
  const handleUpdateClick = () => {
    setIsEditMode(true);
  };
  const handleSaveClick = async () => {
    if (isDraftSaving) return;

    setIsDraftSaving(true);
    const toastId = toast.loading("Saving...", {
      position: "top-right",
    });

    try {
      const payload = {
        ...formInputs,
        subTask: getSubTask,
      };

      const response = await ItemServiceV2.updateTask(payload);

      if (response?.status === 200) {
        toast.dismiss(toastId);
        toast.success("Task updated successfully", {
          position: "top-right",
        });

        setIsEditMode(false);
        gateUpdate();
      } else {
        toast.dismiss(toastId);
        toast.error(response?.message || "Failed to update warehouse", {
          position: "top-right",
        });
      }
    } catch (error) {
      console.error(error);

      toast.dismiss(toastId);
      toast.error("Something went wrong. Please try again.", {
        position: "top-right",
      });
      throw error;
    } finally {
      setIsDraftSaving(false);
    }
  };

  const handleConvertTask = async () => {
    let obj = {
      data: formInputs,
      // contactDetails: getcustomerContactPerson,
      // certifications: getDocumentTypeData,
      type: "Save",
    };
    await ItemServiceV2.updateTask(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "added successfully", {
          duration: 8000,
          position: "top-right",
        });
        navigate(HRConstants.WH_WAREHOUSE_LIST);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      // setDisabled(false);
    });
  };

  useEffect(() => {
    if (getTaskDetails?.length > 0) {
      setFormInputs((prev) => ({ ...prev, ...getTaskDetails[0] }));

      setSubTask(
        Array.isArray(getTaskDetails[0]?.subTask)
          ? getTaskDetails[0].subTask.map((st, index) => ({
              ...subTaskInitialData,
              ...st,
              local_id: index + 1,
              _id: st?._id || "",
            }))
          : [],
      );
    }
    // eslint-disable-next-line
  }, [getTaskDetails]);

  const handleCancelClick = () => {
    setIsEditMode(false);
  };
  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">
                  Task Details{""}
                  <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                    {taskNr}
                  </span>
                  <span>
                    {formInputs?.headerStatus === "New" ? (
                      <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                        {formInputs?.statusHeader}
                      </span>
                    ) : formInputs?.headerStatus === "PO Created" ? (
                      <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                        {formInputs?.headerStatus}
                      </span>
                    ) : formInputs?.headerStatus === "Draft" ? (
                      <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                        {formInputs?.headerStatus}
                      </span>
                    ) : formInputs?.headerStatus === "Created" ? (
                      <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                        {formInputs?.headerStatus}
                      </span>
                    ) : formInputs?.headerStatus === "Deleted" ? (
                      <span className="bg-table-status bg-table-delete-status headerStatusDetailedPage">
                        {formInputs?.headerStatus}
                      </span>
                    ) : formInputs?.headerStatus === "Cancelled" ? (
                      <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                        {formInputs?.headerStatus}
                      </span>
                    ) : formInputs?.headerStatus === "Started" ? (
                      <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                        {formInputs?.headerStatus}
                      </span>
                    ) : formInputs?.headerStatus === "Pending" ? (
                      <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                        {formInputs?.headerStatus}
                      </span>
                    ) : formInputs?.headerStatus === "Completed" ? (
                      <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                        {formInputs?.headerStatus}
                      </span>
                    ) : formInputs?.headerStatus === "Transferred" ? (
                      <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                        {formInputs?.headerStatus}
                      </span>
                    ) : formInputs?.headerStatus === "In Progress" ? (
                      <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                        {formInputs?.headerStatus}
                      </span>
                    ) : formInputs?.headerStatus === "Closed" ? (
                      <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                        {formInputs?.headerStatus}
                      </span>
                    ) : (
                      formInputs?.headerStatus
                    )}
                  </span>
                </h2>
                <p className="subText"> Task Details </p>
              </Col>
            </Row>
            <Row className="mb-2">
              <Col xs={12} className="d-flex justify-content-end gap-2">
                {!isEditMode ? (
                  <button
                    className="btnTable btn-update"
                    onClick={handleUpdateClick}
                    disabled={["deleted", "cancelled"].includes(status)}
                  >
                    <i className="bi bi-pencil-square"></i> Modify
                  </button>
                ) : (
                  <>
                    <button
                      className="btnTable btn-update"
                      onClick={
                        status === "draft" ? handleConvertTask : handleSaveClick
                      }
                    >
                      <i
                        className={`bi ${status === "draft" ? "bi-arrow-repeat" : "bi-save"}`}
                      ></i>
                      {status === "draft" ? " Convert to Task" : " Save"}
                    </button>

                    <button
                      className="btn btn-secondary btn-update"
                      onClick={handleCancelClick}
                    >
                      <i className="bi bi-x-circle"></i> Cancel
                    </button>
                  </>
                )}
              </Col>
            </Row>
            <hr />

            {/* 01 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-down"
                            : "bi-chevron-right"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">TD</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">Task Details </span>
                      <span className="subHeaderTitle">Task Details</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4 d-flex align-items-center">
                      <>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <ComboboxField
                            // label="Client ID"
                            label={
                              <>
                                <i className="bi bi-person-vcard labelIcon"></i>
                                Client ID
                              </>
                            }
                            placeholder="Client"
                            data={getClientList}
                            id="clientName"
                            name="clientName"
                            code="clientCode"
                            description="clientDesc"
                            setValue={formInputs?.clientName}
                            getvalue={setDropdownData}
                            disabled={!isEditMode}
                            // onChangeValue={handleChangeCustomerContacts}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <ComboboxField
                            // label="Project"
                            label={
                              <>
                                <i className="bi bi-kanban labelIcon"></i>
                                Project
                              </>
                            }
                            placeholder="Project"
                            data={getProjectList}
                            id="projectNr"
                            name="projectNr"
                            code="projectCode"
                            description="projectDesc"
                            setValue={formInputs?.projectNr || ""}
                            getvalue={setDropdownData}
                            disabled={!isEditMode}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <div className="d-flex align-items-end gap-2">
                            <div className="flex-grow-1">
                              <ComboboxField
                                // label="Phase"
                                label={
                                  <>
                                    <i className="bi bi-layers labelIcon"></i>
                                    Phase
                                  </>
                                }
                                placeholder="Phase"
                                data={getPhaseList}
                                id="phase"
                                name="phase"
                                code="phaseCode"
                                description="phaseDesc"
                                setValue={formInputs?.phase || ""}
                                getvalue={setDropdownData}
                                disabled={!isEditMode}
                              />
                            </div>
                            <span
                              style={{
                                cursor: "pointer",
                                paddingBottom: "10px",
                              }}
                              className="position-relative"
                              onClick={() =>
                                showServicesLineItem(
                                  getDropdownData?.code,
                                  getSelectedPhaseServices,
                                  "SER",
                                )
                              }
                            >
                              <i className="bi bi-calendar2-week iconTable fs-5"></i>
                              {getSelectedPhaseServices?.length > 0 && (
                                <span
                                  className="badge bg-primary rounded-pill position-absolute"
                                  style={{
                                    top: "-8px",
                                    right: "-10px",
                                    fontSize: "0.65rem",
                                  }}
                                >
                                  {getSelectedPhaseServices.length}
                                </span>
                              )}
                            </span>
                          </div>
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <ComboboxField
                            // label="Task ID"
                            label={
                              <>
                                <i className="bi bi-list-task labelIcon"></i>
                                Task ID
                              </>
                            }
                            placeholder="Task ID"
                            data={taskIdList}
                            id="taskID"
                            name="taskID"
                            code="taskIDCode"
                            description="taskIDDesc"
                            setValue={formInputs?.taskID || ""}
                            getvalue={setDropdownData}
                            disabled={!isEditMode}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <ComboboxField
                            // label="Assigned to"
                            label={
                              <>
                                <i className="bi bi-person-check labelIcon"></i>
                                Assigned to
                              </>
                            }
                            placeholder="Employee"
                            data={getEmpList}
                            id="assignedTo"
                            name="assignedTo"
                            code="assignedToCode"
                            description="assignedToDesc"
                            setValue={formInputs?.assignedTo}
                            getvalue={setDropdownData}
                            disabled={!isEditMode}
                            // onChangeValue={handleChangeCustomerContacts}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <ComboboxField
                            label={
                              <>
                                <i className="bi bi-person-vcard labelIcon"></i>
                                Task Status
                              </>
                            }
                            placeholder=""
                            data={taskStatuss}
                            id="headerStatus"
                            iconClassName="dropdownIcon"
                            name="headerStatus"
                            code="headerStatus"
                            description="headerStatus"
                            setValue={formInputs.headerStatus || ""}
                            getvalue={setDropdownData}
                            disabled={!isEditMode}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            // label="Task Name"
                            label={
                              <>
                                <i className="bi bi-list-task labelIcon"></i>
                                Task Name
                              </>
                            }
                            placeholder=""
                            name="taskName"
                            id="taskName"
                            error={validation?.taskName || ""}
                            value={formInputs?.taskName || ""}
                            onChange={handleInputChange}
                            required={true}
                            disabled={!isEditMode}
                          />
                        </Col>
                        {/* <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <ComboboxField
                            // label="Application"
                            label={
                              <>
                                <i className="bi bi-grid-1x2 labelIcon"></i>
                                Application
                              </>
                            }
                            placeholder=""
                            data={getAppData}
                            id="apps"
                            iconClassName="dropdownIcon"
                            name="apps"
                            code="appsCode"
                            description="appsDesc"
                            setValue={formInputs?.apps || ""}
                            getvalue={setDropdownData}
                            disabled={!isEditMode}
                          />
                        </Col> */}

                        {/* <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <ComboboxField
                            // label="Menu"
                            label={
                              <>
                                <i className="bi bi-menu-button-wide labelIcon"></i>
                                Menu
                              </>
                            }
                            placeholder=""
                            data={getMenu}
                            id="menus"
                            iconClassName="dropdownIcon"
                            name="menus"
                            code="menusCode"
                            description="menusDesc"
                            setValue={formInputs?.menus || ""}
                            getvalue={setDropdownData}
                            disabled={!isEditMode}
                          />
                        </Col> */}
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            type="date"
                            // label="Start Date"
                            label={
                              <>
                                <i className="bi bi-calendar-event labelIcon"></i>
                                Start Date
                              </>
                            }
                            name="startDate"
                            id="startDate"
                            value={formInputs?.startDate}
                            onChange={handleInputChange}
                            // disabled={true}
                            disabled={!isEditMode}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            type="time"
                            // label="Start Time"
                            label={
                              <>
                                <i className="bi bi-clock labelIcon"></i>
                                Start Time
                              </>
                            }
                            name="startTime"
                            id="startTime"
                            value={formInputs?.startTime}
                            onChange={handleInputChange}
                            // disabled={true}
                            disabled={!isEditMode}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            type="date"
                            // label="End Date"
                            label={
                              <>
                                <i className="bi bi-calendar-check labelIcon"></i>
                                End Date
                              </>
                            }
                            name="endDate"
                            id="endDate"
                            value={formInputs?.endDate}
                            onChange={handleInputChange}
                            // disabled={true}
                            disabled={!isEditMode}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            type="time"
                            // label="End Time"
                            label={
                              <>
                                <i className="bi bi-clock-history labelIcon"></i>
                                End Time
                              </>
                            }
                            name="endTime"
                            id="endTime"
                            value={formInputs?.endTime}
                            onChange={handleInputChange}
                            // disabled={true}
                            disabled={!isEditMode}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <FileUploadComponent
                            id="suppoertingDoc"
                            name="suppoertingDoc"
                            label={
                              <>
                                <i className="bi bi-globe labelIcon"></i>
                                Suppoerting Document
                              </>
                            }
                            allowedTypes={[
                              "image/png",
                              "image/jpeg",
                              "application/pdf",
                            ]}
                            multiple={true} // Change to false for single file selection
                            required={true}
                            onSuccessUpload={onSuccessUploadDocumentType}
                            value={formInputs?.suppoertingDoc || ""}
                            disabled={!isEditMode}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={1}
                          lg={1}
                          className="commTopButtonRightLeftPadding d-flex align-items-center"
                        >
                          {(formInputs?.suppoertingDoc && (
                            <img
                              src="assets/img/newIcons/attached-file.png"
                              className="mt-1 attachmentIcon"
                              alt="attachments"
                              onClick={() =>
                                handleViewFile(formInputs?.suppoertingDoc)
                              }
                            />
                          )) ||
                            "--"}
                        </Col>
                        {/* Instructions*/}
                        <div className="accordion mb-4" id="accordionExample">
                          <div className="accordion-item">
                            <h2 className="accordion-header">
                              <Row className="accordion-button">
                                <Col
                                  xs={1}
                                  md={1}
                                  lg={1}
                                  className="text-center logoBtn"
                                >
                                  <span className="iconLogo">TI</span>
                                </Col>
                                <Col xs={8} md={9} lg={9}>
                                  <span className="headerTitle">
                                    Task Instructions
                                  </span>
                                  <span className="subHeaderTitle">
                                    Instructions Section
                                  </span>
                                </Col>
                              </Row>
                            </h2>
                            <div>
                              <div className="accordion-body">
                                <Row className="p-4">
                                  <Col xs={12} md={12} lg={12}>
                                    <RichTextEditor
                                      value={editorContent}
                                      onChange={handleEditorChange}
                                      disabled={!isEditMode}
                                    />
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* 08 Sub Task*/}
          <div className="accordion mb-4" id="accordionExample">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <Row className="accordion-button">
                  <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                    <i
                      className={`bi ${
                        isCardVisible2 ? "bi-chevron-right" : "bi-chevron-down"
                      }`}
                      onClick={toggleCardVisibility2}
                    ></i>
                  </Col>
                  <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                    <span className="iconLogo">ST</span>
                  </Col>
                  <Col xs={12} md={8} lg={8}>
                    <span className="headerTitle">Sub Task</span>
                    <span className="subHeaderTitle">Sub Task</span>
                  </Col>
                  <Col xs={4} md={2} lg={2} className="">
                    <button
                      className="btnTable"
                      onClick={() => addSubTask()}
                      // disabled={getDisabledStatus}
                    >
                      <i className="bi bi-plus-lg"></i> Add Sub Task
                    </button>
                  </Col>
                </Row>
              </h2>

              {/* Banker Information */}
              <div
                className={`accordion-collapse collapse show ${
                  isCardVisible2 ? "visible" : ""
                }`}
              >
                <div className="accordion-body">
                  {/* To Load Dynamic Bank Info Form */}
                  {getSubTask &&
                    getSubTask?.map((item, index) => (
                      <div key={item.local_id}>
                        <Row className="pt-2 pb-2">
                          <Col
                            xs={12}
                            md={12}
                            lg={12}
                            className="commTopButtonRightLeftPadding"
                          >
                            <h6>Sub Task {index + 1}</h6>
                            <span
                              className="deleteIconAccordion"
                              onClick={() => removeSubTask(index)}
                            >
                              {" "}
                              <i className="bi bi-x-circle"></i>{" "}
                            </span>
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              // label="Sub Task Name"
                              label={
                                <>
                                  <i className="bi bi-list-task labelIcon"></i>
                                  Task Name
                                </>
                              }
                              name="subTaskName"
                              placeholder=""
                              value={item?.subTaskName || ""}
                              onChange={(e) =>
                                handleSubTask(
                                  item.local_id,
                                  "subTaskName",
                                  e.target.value,
                                )
                              }
                              disabled={!isEditMode}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <ComboboxField
                              // label="Task Priority"
                              label={
                                <>
                                  <i className="bi bi-flag labelIcon"></i>
                                  Task Priority
                                </>
                              }
                              placeholder=""
                              data={priority}
                              id={`priority_${item.local_id}`}
                              iconClassName="dropdownIcon"
                              name="priority"
                              code="priorityCode"
                              description="priorityDesc"
                              setValue={item?.priority || ""}
                              getvalue={(data) =>
                                handleSubTask(
                                  item.local_id,
                                  "priority",
                                  data?.name ||
                                    data?.value ||
                                    data?.priorityDesc ||
                                    "",
                                )
                              }
                              disabled={!isEditMode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              type="date"
                              // label="Start Date"
                              label={
                                <>
                                  <i className="bi bi-calendar-event labelIcon"></i>
                                  Start Date
                                </>
                              }
                              name="startDate"
                              id={`startDate_${item.local_id}`}
                              value={item?.startDate || ""}
                              onChange={(e) =>
                                handleSubTask(
                                  item.local_id,
                                  "startDate",
                                  e.target.value,
                                )
                              }
                              disabled={!isEditMode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              type="time"
                              // label="Start Time"
                              label={
                                <>
                                  <i className="bi bi-clock labelIcon"></i>
                                  Start Time
                                </>
                              }
                              name="startTime"
                              id={`startTime_${item.local_id}`}
                              value={item?.startTime || ""}
                              onChange={(e) =>
                                handleSubTask(
                                  item.local_id,
                                  "startTime",
                                  e.target.value,
                                )
                              }
                              disabled={!isEditMode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              type="date"
                              // label="End Date"
                              label={
                                <>
                                  <i className="bi bi-calendar-check labelIcon"></i>
                                  End Date
                                </>
                              }
                              name="endDate"
                              id={`endDate_${item.local_id}`}
                              value={item?.endDate || ""}
                              onChange={(e) =>
                                handleSubTask(
                                  item.local_id,
                                  "endDate",
                                  e.target.value,
                                )
                              }
                              disabled={!isEditMode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              type="time"
                              // label="End Time"
                              label={
                                <>
                                  <i className="bi bi-clock-history labelIcon"></i>
                                  End Time
                                </>
                              }
                              name="endTime"
                              id={`endTime_${item.local_id}`}
                              value={item?.endTime || ""}
                              onChange={(e) =>
                                handleSubTask(
                                  item.local_id,
                                  "endTime",
                                  e.target.value,
                                )
                              }
                              disabled={!isEditMode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              className="inputBox"
                              // label="Remarks"
                              // Remarks
                              label={
                                <>
                                  <i className="bi bi-chat-left-text labelIcon"></i>
                                  Remarks
                                </>
                              }
                              name="remarks"
                              id={`remarks_${item.local_id}`}
                              value={item?.remarks || ""}
                              error={
                                validation?.[`${item.local_id}_remarks`] || ""
                              }
                              onChange={(e) =>
                                handleSubTask(
                                  item.local_id,
                                  "remarks",
                                  e.target.value,
                                )
                              }
                              disabled={!isEditMode}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding d-flex"
                          >
                            <FileUploadComponent
                              id={`supportingDoc_${item.local_id}`}
                              name="supportingDoc"
                              label={
                                <>
                                  <i className="bi bi-file-earmark-richtext labelIcon"></i>
                                  Supporting Document
                                </>
                              }
                              allowedTypes={[
                                "image/png",
                                "image/jpeg",
                                "application/pdf",
                              ]}
                              multiple={true}
                              required={true}
                              disabled={!isEditMode}
                              onSuccessUpload={(data) => {
                                handleSubTask(
                                  item.local_id,
                                  "supportingDoc",
                                  data.attachmentId,
                                );
                              }}
                              value={item?.supportingDoc || ""}
                            />

                            <div className="d-flex align-items-center pe-2">
                              {(item?.supportingDoc && (
                                <img
                                  src="assets/img/newIcons/attached-file.png"
                                  className="mt-1 attachmentIcon"
                                  alt="attachments"
                                  onClick={() =>
                                    handleViewFile(item?.supportingDoc)
                                  }
                                />
                              )) ||
                                "--"}
                            </div>
                          </Col>
                        </Row>
                        <Col
                          xs={12}
                          md={12}
                          lg={12}
                          className="commTopButtonRightLeftPadding"
                        >
                          <hr />
                        </Col>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
          {/* 08 Delegation*/}
          {/* {getDelegation?.length > 0 && ( */}
          {Object.keys(getDelegation || {}).length > 0 && (
            <>
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible3
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility3}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">DH</span>
                      </Col>
                      <Col xs={12} md={8} lg={8}>
                        <span className="headerTitle">Delegation History</span>
                        <span className="subHeaderTitle">
                          View of Delegation List{" "}
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${
                      isCardVisible3 ? "visible" : ""
                    }`}
                    // aria-labelledby="headingOne"
                    // data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <DataTable
                            title=""
                            columns={delegationColumns}
                            // data={getDelegation}
                            data={[getDelegation]}
                            // progressPending={loading}
                            paginationRowsPerPageOptions={
                              Constants.ROW_PER_PAGE
                            }
                            pagination
                            // paginationServer
                            // paginationTotalRows={totalRows}
                            // onChangeRowsPerPage={handlePerRowsChange}
                            // onChangePage={handlePageChange}
                            selectableRows
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          <FailureModal
            show={getShowFailureModal}
            onHide={hideFailureModal}
            failureStockData={getFailureCashRequestUpdate}
          />
          <FileViewerModal
            show={getShowFileViewModal}
            onHide={handleViewFileHide}
            fileid={getFileViewData}
          />
          <HrProjectServices
            index={getServicesLineItemIndex}
            headername={getServiceTitle}
            show={getServicesLineItemModal}
            onHide={hideServicesLineItem}
            servicescheduledata={handlePhases}
            showcurrentdata={getServicesLineItemText}
            purchasetype={formInputs.purchaseTypeCode}
          />
        </Col>
      </Row>
    </main>
  );
};

export default TaskDetails;
